export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15112.cadbe4a1.jpg";